import { Badge } from '@/components/ui/badge'
import CharacterClassIcon from './CharacterClassIcon'
import EventStatusIcon from './EventStatusIcon'
import { cn } from '@/lib/utils'
import { useUpcomingEventDetails } from './UpcomingEvent'

const EventParticipationSummary = ({
  eventReference,
}: {
  eventReference: wowaudit.EventReference
}) => {
  const {
    characterReference,
    amountPresent,
    participants,
    hasSufficientParticipants,
  } = useUpcomingEventDetails(eventReference)

  return (
    <>
      <Badge variant='outline' className='flex items-center gap-2'>
        {characterReference ? (
          <>
            <CharacterClassIcon
              className='ml-[-8px]'
              size='small'
              characterClass={characterReference.characterClass}
            />
            <span>{characterReference.name}</span>
            <EventStatusIcon
              status={participants[characterReference.id].status}
            />
          </>
        ) : (
          <span className='text-muted-foreground font-normal'>
            Not signed up
          </span>
        )}
      </Badge>
      <span className='flex gap-1 text-xs'>
        <span
          className={cn(
            hasSufficientParticipants ? '' : 'text-warning-foreground',
          )}
        >
          {amountPresent}
        </span>
        <span>/</span>
        <span>{eventReference.participantReferences.length}</span>
      </span>
    </>
  )
}

export default EventParticipationSummary
